module.exports = __webpack_public_path__ + "static/media/cig.48a48889.png";